//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'WeightAndAgePercentileOfInfants',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: ''
      },
      dataList1: [
        { name: '男', value: '0' },
        { name: '女', value: '1' }
      ],
      dataList2: [
        { name: '0月', value: '0' },
        { name: '1月', value: '1' },
        { name: '2月', value: '2' },
        { name: '3月', value: '3' },
        { name: '4月', value: '4' },
        { name: '5月', value: '5' },
        { name: '6月', value: '6' },
        { name: '7月', value: '7' },
        { name: '8月', value: '8' },
        { name: '9月', value: '9' },
        { name: '10月', value: '10' },
        { name: '11月', value: '11' },
        { name: '1岁', value: '12' },
        { name: '1岁1月', value: '13' },
        { name: '1岁2月', value: '14' },
        { name: '1岁3月', value: '15' },
        { name: '1岁4月', value: '16' },
        { name: '1岁5月', value: '17' },
        { name: '1岁6月', value: '18' },
        { name: '1岁7月', value: '19' },
        { name: '1岁8月', value: '20' },
        { name: '1岁9月', value: '21' },
        { name: '1岁10月', value: '22' },
        { name: '1岁11月', value: '23' },
        { name: '2岁', value: '24' },
        { name: '2岁3月', value: '25' },
        { name: '2岁6月', value: '26' },
        { name: '2岁9月', value: '27' },
        { name: '3岁', value: '28' }
      ],
      comparisontable0: [{'p3': 2.8, 'p25': 3.2, 'p75': 3.7, 'p97': 4.2}, {'p3': 3.7, 'p25': 4.2, 'p75': 4.9, 'p97': 5.6}, {'p3': 4.7, 'p25': 5.4, 'p75': 6.2, 'p97': 7.1}, {'p3': 5.5, 'p25': 6.3, 'p75': 7.3, 'p97': 8.3}, {'p3': 6.1, 'p25': 7, 'p75': 8.1, 'p97': 9.2}, {'p3': 6.6, 'p25': 7.5, 'p75': 8.6, 'p97': 9.8}, {'p3': 6.9, 'p25': 7.9, 'p75': 9.1, 'p97': 10.3}, {'p3': 7.2, 'p25': 8.2, 'p75': 9.5, 'p97': 10.8}, {'p3': 7.5, 'p25': 8.5, 'p75': 9.8, 'p97': 11.1}, {'p3': 7.7, 'p25': 8.7, 'p75': 10.1, 'p97': 11.5}, {'p3': 7.9, 'p25': 9, 'p75': 10.3, 'p97': 11.8}, {'p3': 8.1, 'p25': 9.2, 'p75': 10.6, 'p97': 12}, {'p3': 8.3, 'p25': 9.4, 'p75': 10.8, 'p97': 12.3}, {'p3': 8.4, 'p25': 9.6, 'p75': 11, 'p97': 12.5}, {'p3': 8.6, 'p25': 9.7, 'p75': 11.2, 'p97': 12.8}, {'p3': 8.8, 'p25': 9.9, 'p75': 11.4, 'p97': 13}, {'p3': 9, 'p25': 10.1, 'p75': 11.7, 'p97': 13.3}, {'p3': 9.1, 'p25': 10.3, 'p75': 11.9, 'p97': 13.5}, {'p3': 9.3, 'p25': 10.5, 'p75': 12.1, 'p97': 13.8}, {'p3': 9.5, 'p25': 10.7, 'p75': 12.3, 'p97': 14}, {'p3': 9.7, 'p25': 10.9, 'p75': 12.6, 'p97': 14.3}, {'p3': 9.8, 'p25': 11.1, 'p75': 12.8, 'p97': 14.6}, {'p3': 10, 'p25': 11.3, 'p75': 13, 'p97': 14.8}, {'p3': 10.2, 'p25': 11.5, 'p75': 13.3, 'p97': 15.1}, {'p3': 10.4, 'p25': 11.7, 'p75': 13.5, 'p97': 15.4}, {'p3': 10.8, 'p25': 12.2, 'p75': 14.1, 'p97': 16.1}, {'p3': 11.2, 'p25': 12.7, 'p75': 14.7, 'p97': 16.7}, {'p3': 11.6, 'p25': 13.2, 'p75': 15.2, 'p97': 17.4}, {'p3': 12, 'p25': 13.6, 'p75': 15.8, 'p97': 18}],
      comparisontable1: [{'p3': 2.7, 'p25': 3.1, 'p75': 3.6, 'p97': 4.1}, {'p3': 3.5, 'p25': 4, 'p75': 4.6, 'p97': 5.3}, {'p3': 4.4, 'p25': 5, 'p75': 5.8, 'p97': 6.6}, {'p3': 5.1, 'p25': 5.8, 'p75': 6.7, 'p97': 7.6}, {'p3': 5.6, 'p25': 6.4, 'p75': 7.4, 'p97': 8.4}, {'p3': 6, 'p25': 6.9, 'p75': 7.9, 'p97': 9.1}, {'p3': 6.4, 'p25': 7.2, 'p75': 8.4, 'p97': 9.6}, {'p3': 6.7, 'p25': 7.6, 'p75': 8.8, 'p97': 10}, {'p3': 6.9, 'p25': 7.9, 'p75': 9.1, 'p97': 10.4}, {'p3': 7.2, 'p25': 8.1, 'p75': 9.4, 'p97': 10.8}, {'p3': 7.4, 'p25': 8.3, 'p75': 9.6, 'p97': 11.1}, {'p3': 7.6, 'p25': 8.6, 'p75': 9.9, 'p97': 11.4}, {'p3': 7.7, 'p25': 8.8, 'p75': 10.1, 'p97': 11.6}, {'p3': 7.9, 'p25': 9, 'p75': 10.4, 'p97': 11.9}, {'p3': 8.1, 'p25': 9.2, 'p75': 10.6, 'p97': 12.2}, {'p3': 8.3, 'p25': 9.3, 'p75': 10.8, 'p97': 12.4}, {'p3': 8.4, 'p25': 9.5, 'p75': 11, 'p97': 12.7}, {'p3': 8.6, 'p25': 9.7, 'p75': 11.3, 'p97': 12.9}, {'p3': 8.8, 'p25': 9.9, 'p75': 11.5, 'p97': 13.2}, {'p3': 9, 'p25': 10.1, 'p75': 11.7, 'p97': 13.5}, {'p3': 9.1, 'p25': 10.3, 'p75': 12, 'p97': 13.8}, {'p3': 9.3, 'p25': 10.5, 'p75': 12.2, 'p97': 14}, {'p3': 9.5, 'p25': 10.7, 'p75': 12.4, 'p97': 14.3}, {'p3': 9.7, 'p25': 10.9, 'p75': 12.6, 'p97': 14.6}, {'p3': 9.8, 'p25': 11.1, 'p75': 12.9, 'p97': 14.8}, {'p3': 10.3, 'p25': 11.6, 'p75': 13.5, 'p97': 15.5}, {'p3': 10.7, 'p25': 12.1, 'p75': 14.1, 'p97': 16.2}, {'p3': 11.1, 'p25': 12.6, 'p75': 14.6, 'p97': 16.9}, {'p3': 11.5, 'p25': 13.1, 'p75': 15.3, 'p97': 17.7}],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.comparisontable0.length, 777)
      let form = JSON.parse(JSON.stringify(self.form))
      if (form.data3 > 30 || form.data3 < 0) return
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        return ''
      }
      let result = form.data3
      console.log(form, 666)
      const comparisontable = self['comparisontable' + form.data1][form.data2]
      console.log(comparisontable, 888)
      if (result <= comparisontable.p3) {
        self.descTxt = '评价等级:下(P3)'
      } else if (result >= comparisontable.p3 && result < comparisontable.p25) {
        self.descTxt = '评价等级:中下(P3-P25)'
      } else if (result >= comparisontable.p25 && result < comparisontable.p75) {
        self.descTxt = '评价等级:中(P25-P75)'
      } else if (result >= comparisontable.p75 && result < comparisontable.p97) {
        self.descTxt = '评价等级:中上(P75-P97)'
      } else if (result >= comparisontable.p97) {
        self.descTxt = '评价等级:上(P97)'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/WeightAndAgePercentileOfInfants.vue